import {useQuery} from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetGrades = () => {
    const {
        isFetching: isLoading, data: grades, error,
    } = useQuery({
        queryKey: ["grades"],
        queryFn: () => axiosManager.get$("grades").then((response) => response?.data),
        initialData: [],
        retry: 0,
    });

    const gradesOptions = (grades || []).map((item) => ({value: item.notionalYearGroupId, label: item.name}));

    return {
        isLoading, grades, error, gradesOptions,
    };

};
